import {Provider} from '@angular/core';

import {ListAgreementUseCasePort} from '@features/agreement/application/use_cases/list-agreement/list-agreement.use-case.port';

import {ListAgreementUseCase} from '@features/agreement/application/use_cases/list-agreement/list-agreement.use-case';
import {AgreementHttpAdapterProvider} from '@features/agreement/infrastructure/http/agreement.http.adapter.provider';

export const ListAgreementUseCaseProvider: Provider[] = [
  ...AgreementHttpAdapterProvider,
  {
    provide: ListAgreementUseCasePort,
    useClass: ListAgreementUseCase
  }
];
